import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      duration={15000}
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          error:
            "group-[.toaster]:!bg-destructive group-[.toaster]:!text-destructive-foreground group-[.toaster]:!border-destructive [&_[data-description]]:!text-destructive-foreground/90 [&_[data-button]]:!bg-destructive-foreground [&_[data-button]]:!text-destructive [&_[data-close-button]]:!bg-destructive-foreground [&_[data-close-button]]:!text-destructive [&_[data-close-button]]:!border-destructive-foreground/30",
          closeButton:
            "!absolute !top-1.5 !right-1.5 !left-auto !transform-none !border-border/50 hover:!bg-muted/20",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
